import { render, staticRenderFns } from "./memberCardPoster.vue?vue&type=template&id=80be4b3e&scoped=true&"
import script from "./memberCardPoster.vue?vue&type=script&lang=js&"
export * from "./memberCardPoster.vue?vue&type=script&lang=js&"
import style0 from "./memberCardPoster.vue?vue&type=style&index=0&id=80be4b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80be4b3e",
  null
  
)

export default component.exports